import React, { useEffect, useState } from "react";
import { getAhaProductIdentifiers } from "../../../api/apiClient";

/** Read-only list of a product's modules and their AHA module IDs in the connected environment. */
export default function ModuleList({ productKey }) {
  const [state, setState] = useState({ loading: true, modules: [], failed: false });
  useEffect(() => {
    let cancelled = false;
    getAhaProductIdentifiers(productKey)
      .then((data) => { if (!cancelled) setState({ loading: false, modules: data?.modules || [], failed: false }); })
      .catch(() => { if (!cancelled) setState({ loading: false, modules: [], failed: true }); });
    return () => { cancelled = true; };
  }, [productKey]);

  if (state.loading) return <p className="muted">Loading modules…</p>;
  if (state.failed) return <p className="muted">Modules could not be loaded.</p>;
  if (state.modules.length === 0) return <p className="muted">This product has no modules.</p>;
  return (
    <div className="ac-mods">
      {state.modules.map((m) => (
        <React.Fragment key={m.key}>
          <span>{m.name}</span>
          <span className="mono">{m.moduleId ?? "—"}</span>
        </React.Fragment>
      ))}
    </div>
  );
}
